var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNofile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 68,
    viewBox: "0 0 50 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 16.7906V17.5835H33.3333V0.833496H34.1223C34.951 0.8335 35.7459 1.16436 36.3319 1.75331L49.0846 14.5698C49.6707 15.1588 50 15.9576 50 16.7906ZM32.2917 21.771C30.5729 21.771 29.1667 20.3577 29.1667 18.6304V0.833496H3.125C1.39909 0.833496 0 2.23958 0 3.97412V64.6929C0 66.4274 1.39909 67.8335 3.125 67.8335H46.875C48.6009 67.8335 50 66.4274 50 64.6929V21.771H32.2917ZM14.6543 23.8647C18.1061 23.8647 20.9043 26.6769 20.9043 30.146C20.9043 33.6151 18.1061 36.4272 14.6543 36.4272C11.2025 36.4272 8.4043 33.6151 8.4043 30.146C8.4043 26.6769 11.2026 23.8647 14.6543 23.8647ZM41.7376 55.271H8.4043L8.46745 48.9263L13.6126 43.7554C14.2228 43.1422 15.149 43.2056 15.7591 43.8188L20.9043 48.9897L34.3828 35.4438C34.993 34.8306 35.9823 34.8306 36.5926 35.4438L41.7376 40.6147V55.271Z",
    fill: "#C7C7C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNofile);
export default __webpack_public_path__ + "static/media/nofile.968988098730dfb2b1bae8fdc75a6971.svg";
export { ForwardRef as ReactComponent };